import { FilterButton } from 'ogp/components/views/administration/shared';
import { Toolbox } from 'redesign';
import { PaymentUsersToolboxProps } from './payment-users-toolbox.types';

export const PaymentUsersToolbox = ({
  selectedFilterCount,
  toggleFilters,
}: PaymentUsersToolboxProps) => {
  return (
    <Toolbox underline={false}>
      <Toolbox.PushRight>
        <FilterButton onClick={toggleFilters} nrOfActiveFilters={selectedFilterCount} />
      </Toolbox.PushRight>
    </Toolbox>
  );
};
